module.exports = __webpack_public_path__ + "static/img/3_6_1.d0c7ffd4.jpg";